import { Link } from "react-router-dom";

const Arr = () => (
  <svg className="arr" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M3 8h9m0 0L8 4m4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function CTA({
  eyebrow = "Get started",
  title,
  text,
  primary = { to: "/contact", label: "Request a pilot" },
  secondary = { to: "/platform", label: "Explore the platform" },
  emailFallback = false,
}) {
  return (
    <section className="section cta" data-testid="cta-section">
      <div className="container">
        <div className="reveal">
          <div className="eyebrow eyebrow--center eyebrow--light" style={{ justifyContent: "center", marginBottom: 24 }}>
            {eyebrow}
          </div>
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
          <p>{text}</p>
          <div className="cta__actions">
            <Link to={primary.to} className="btn btn--light" data-testid="cta-primary">{primary.label}</Link>
            {emailFallback ? (
              <a href="mailto:hello@devnco.in" className="btn btn--outline-light" data-testid="cta-secondary">{secondary.label}</a>
            ) : (
              <Link to={secondary.to} className="btn btn--outline-light" data-testid="cta-secondary">{secondary.label}</Link>
            )}
          </div>
          <div className="cta__url">docketidp.com</div>
        </div>
      </div>
    </section>
  );
}

export { Arr };
